module.exports = __webpack_public_path__ + "public/img/uxb_order_noData.2eedbf4a.png";